import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { AuthContext } from '../store/AuthProvider.js'
import axios from 'axios'
import { getTopologyVppGridList } from '../querys/querys.js'

const useGridList = () => {
    const { user } = React.useContext(AuthContext)
    
    const {
        data: gridList,
        isError,
        error,
        ...arg
    } = useQuery({
        queryKey: ['getTopologyVppGridList', {}],
        queryFn: async () => {
            try {
                const response = await axios({
                    method: 'POST',
                    // eslint-disable-next-line no-undef
                    url: process.env.REACT_APP_API,
                    headers: {
                        Authorization: user.token,
                    },
                    data: {
                        query: getTopologyVppGridList,
                    },
                })
                return response.data.data // Response received from the API
            } catch (error) {
                return await Promise.reject(error)
            }
        },
        enabled: !!user.token,
    })

    return { gridList, isError, error, ...arg }
}

export default useGridList
